import {styled} from '@mui/material';
import React, {FC} from 'react';
import { useTranslation } from 'react-i18next';
import {TextInput, FormButton} from 'thermia-react-container';

const StyledAdminContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: 0.5,
  flexDirection: 'column',
  padding: `${theme.spacing(4)} ${theme.spacing(4)}`,
  gap: theme.spacing(2),
  minWidth: '680px'
}));

const AdminSearchContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(4),
  backgroundColor: theme.palette.tableRow.main,
  display: 'flex',
  alignItems: 'center'
}));

const StyledGlobalSearchContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(4),
  backgroundColor: theme.palette.tableRow.main,
  display: 'flex',
  alignItems: 'center'
}));

type Props = {
  isLoadingResults: boolean;
  searchAction: () => void;
  textInput?: string;
  setTextInput: React.Dispatch<React.SetStateAction<string>>;
};

const AdminPartnersSearch: FC<Props> = ({textInput, setTextInput, isLoadingResults, searchAction}) => {
  const { t } = useTranslation('registrations');

  return (
    <StyledGlobalSearchContainer>
      <StyledAdminContainer>
        <AdminSearchContainer>
            <span onKeyDown={(e) => { if (e.key === 'Enter') searchAction(); }} style={{ flex: 1 }}>
              <TextInput
              onChangeText={(e) => {
                setTextInput(e);
              }}
              placeholder={t('registrations.general.partnerSearch')}
              value={textInput}
              />
            </span>
          <FormButton
          title={t('registrations.general.search')}
          variant="contained"
          loading={isLoadingResults}
          onClick={searchAction}
          style={{
            marginLeft: 10,
            borderRadius: 200,
            fontSize: 14,
            width: 210,
            padding: 12
          }}></FormButton>
        </AdminSearchContainer>
      </StyledAdminContainer>
    </StyledGlobalSearchContainer>
  );
};

export default AdminPartnersSearch;
